var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('h4',{staticClass:"px-2 pb-3 text-center text-primary text-uppercase"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('b-card',{staticClass:"my-md-4 bg-none",attrs:{"body-class":"px-0"}},[_c('b-card-text',{domProps:{"innerHTML":_vm._s(_vm.content)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }